import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import AlwaysOnRateOptionMobile from '../AlwaysOnRateOptionMobile'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { pluralizeToString } from 'lib/string/pluralize'

const OptionsContainer = styled.div`
  padding: ${rem(12)} ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.default.eight};
`

interface Props {
  offer: App.Offer;
  airports: Array<App.Airport>;
  packageViews: Array<OfferPackageOptionView>;
}

function AlwaysOnPackageOptionsModalTab(props: Props) {
  const { offer, airports, packageViews } = props

  const destinationAirport = useMemo(() => airports.find(({ code }) => code === offer.flightDestinationPort), [airports, offer.flightDestinationPort])

  return (
    <Pane background="neutral-six">
      <Group direction="vertical" gap={8}>
        {packageViews.length > 1 && (
          <OptionsContainer>
            <BodyText variant="small" colour="neutral-three">{pluralizeToString('package option', packageViews.length)} available</BodyText>
          </OptionsContainer>
        )}
        {packageViews.map((view, index) => <Pane key={view.package.uniqueKey}>
          <AlwaysOnRateOptionMobile
            offer={offer}
            optionNumber={index + 1}
            packageView={view}
            flightDestination={destinationAirport}
            showOptionLabel={packageViews.length > 1}
          />
        </Pane>)}
      </Group>
    </Pane>
  )
}

export default withOfferPageAndReduxState((state, appState) => {
  return {
    offer: state.offer,
    airports: appState.geo.airports,
  }
})(AlwaysOnPackageOptionsModalTab)
